import { customRuleApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const RULE_PREVIEWS = createNamedActions('rulePreviews', {
  GET_RULE_PREVIEWS: 'GET_RULE_PREVIEWS',
});

export const getRulePreviewsAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await customRuleApi.getCustomRule();

  return dispatch({
    type: RULE_PREVIEWS.GET_RULE_PREVIEWS,
    payload: data,
  });
});
